// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowLeft(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowLeft" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.73529 13.2662L13.5026 19.236L11.6947 21L3 12L11.6947 3L13.5026 4.76397L7.73529 10.7338L21 10.7338L21 13.2662L7.73529 13.2662Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowLeft.js.map